import { useQuery } from "@apollo/client";
import { Button, Dialog, DialogContent } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { client } from "../../..";
import { buildSaleStatement, SaleStatement } from "../../../models/contract/SaleStatement";
import { StatementComponent } from "./StatementComponent";
import { GetAdjustmentStatement } from "../../../api/contract";
import { Loader } from "../../../components/Loader";
import { colorPrimary } from "../../../rsc/colors/colors";

type Props = {
    isOpen: boolean
    onClose: () => void
    statementId: number
}

export const DialogStatement: React.FC<Props> = ({ isOpen, onClose, statementId }) => {

    const [statement, setStatement] = useState<SaleStatement>()

    const { loading, error, refetch } = useQuery(GetAdjustmentStatement, {
        client: client,
        skip: !statementId,
        variables: {
            statementId: statementId,
        },
        onCompleted(data) {
            const raw = data?.nac?.statement ?? data?.nam?.statement
            setStatement(raw ? buildSaleStatement(raw) : undefined)
        },
    })

    return <Dialog open={isOpen} onClose={() => { onClose(); }} maxWidth="sm" fullWidth>
        <DialogContent className="pem-modal-content">
            <div className="pem-modal-inner">
                <h3 className="pem-modal-title">
                    {t('adjustment')}
                </h3>

                <div className="pempem-flex-row-center">
                    <StatementComponent statement={statement} />
                </div>
            </div>
            <div className="pem-actions">
                <Button
                    onClick={() => onClose()}
                    variant="contained"
                    style={{
                        backgroundColor: colorPrimary(),
                        color: 'white',
                        textTransform: 'none',
                        boxShadow: '0 4px 12px rgba(0, 151, 167, 0.3)'
                    }}
                >
                    {t('close')}
                </Button>
            </div>
            <Loader isLoading={loading} fullScreen={false} />
        </DialogContent>
    </Dialog>
}